export enum LoginLayoutType {
  ESSENTIAL = 'ESSENTIAL',
  SPLIT = 'SPLIT',
  IMMERSIVE = 'IMMERSIVE',
}
